import { render } from "./vcurriculumlistedit.vue?vue&type=template&id=fae9831c&scoped=true"
import script from "./vcurriculumlistedit.vue?vue&type=script&lang=js"
export * from "./vcurriculumlistedit.vue?vue&type=script&lang=js"

import "./vcurriculumlistedit.vue?vue&type=style&index=0&id=fae9831c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae9831c"]])

export default __exports__